import React, { useContext } from 'react';
import styled from 'styled-components';
import { MenuContext } from '../../utils/context';

const HamburgerLabel = styled.label`
  cursor: pointer;
  display: none;
  z-index: 3;

  @media screen and (max-width: 768px) {
    display: flex;
  }
`;

const HamburgerSvg = styled.svg`
  height: 3em;
  transition: transform 600ms cubic-bezier(0.4, 0, 0.2, 1);
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(-45deg)' : 'rotate(0)')};
`;

const Line = styled.path`
  fill: none;
  stroke: #9d9d9d;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1;
  transition: stroke-dasharray 600ms cubic-bezier(0.4, 0, 0.2, 1),
    stroke-dashoffset 600ms cubic-bezier(0.4, 0, 0.2, 1);

  &.line-top-bottom {
    stroke-dasharray: ${({ $isOpen }) => ($isOpen ? '20 300' : '12 63')};
    stroke-dashoffset: ${({ $isOpen }) => ($isOpen ? '-32.42' : '0')};
  }
`;

function Hamburger() {
  const { isOpen, toggleOpen } = useContext(MenuContext);

  return (
    <HamburgerLabel onClick={toggleOpen} className='z-30'>
      <HamburgerSvg viewBox="0 0 32 32" $isOpen={isOpen}>
        <Line
          className="line line-top-bottom"
          d="M27 10 13 10C10.8 10 9 8.2 9 6 9 3.5 10.8 2 13 2 15.2 2 17 3.8 17 6L17 26C17 28.2 18.8 30 21 30 23.2 30 25 28.2 25 26 25 23.8 23.2 22 21 22L7 22"
          $isOpen={isOpen}
        />
        <Line className="line" d="M7 16 27 16" />
      </HamburgerSvg>
    </HamburgerLabel>
  );
}

export default Hamburger;
